import RequestChannelController from './channel';

export default class RequestChannelFields extends RequestChannelController {}
